import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, timeout } from 'rxjs/operators';
import { IBasculaSentidoRequest, IMensajesRequest, IResponseApiOnlyServices, StatusSentidoDetalle } from '../model/modelOnlyServices';
import { LogisticaDiccionario, logisticaModulo} from '../logistica-diccionario';
import { CommonService } from '../../../shared/utils/common.service';
import { UtilsService } from '../../../shared/utils/utils.service';

@Injectable({
    providedIn: 'root'
  })

/**
 * Ya no se integra cliente servidor, se integra back to back según GLPI T.45578 
 * Se mantienen clases pero omite el apikey desde la config. de la balanza
 * Se ajusta para manter la validación sin el apiKEY
 * Antes de ajustar verificar el proceso.
 */

  export class EquiposMarquesinaService{

    private ONLY_API_KEY: string;
    private readonly response  : string;
    private readonly urlOnlyControlBalanza  : string;
    private readonly diccionarioUrlOnlyCon  : any;
    private readonly usuarioActual : string;

    constructor(
      private commom: CommonService, 
      private utilServices: UtilsService, 
      private http: HttpClient) {
      this.urlOnlyControlBalanza    = this.utilServices.getUrlBascula();
      this.diccionarioUrlOnlyCon    = logisticaModulo.urlOnlyIntegracion;
      this.response = this.diccionarioUrlOnlyCon.respuesta
      this.usuarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin')).login2;
    }

    public setIntegration_ApiKey(API_KEY: string){
      this.ONLY_API_KEY = API_KEY;
    }

    public getValidationApiKey(){
      let isInValido: Boolean = this.ONLY_API_KEY == null || this.ONLY_API_KEY == undefined;
      if(isInValido) {
        //console.warn("API KEY ONLY CONTROL INTEGRACION SENSORES ES INVALIDA, INICIALIZAR SERVICIOS");
        console.warn("ONLY CONTROL INTEGRACION SENSORES ES INVALIDA, INICIALIZAR SERVICIOS");
        return false;
      }
      return true;
    }
    
    public setHeader(): HttpHeaders{
      return new HttpHeaders({'key': this.ONLY_API_KEY});
    }

    public getHeader(): HttpHeaders{
      return this.setHeader()
    }

    //Verifica conexion
    getStatuConecc(){
      if (!this.getValidationApiKey()) return;
      const url = this.urlOnlyControlBalanza+this.diccionarioUrlOnlyCon.coneccion+"/"+this.usuarioActual;
      //const headers = this.getHeader();
      let  response;
      
      //response = this.http.get<IResponseApiOnlyServices<String>>(url, {headers});
      //response = this.http.get(url);
      response = this.commom.peticionGetConHeader(url);
      return response;
    }

    //Sentido bascula
    postSentidoBascula(request: IBasculaSentidoRequest){
      if (!this.getValidationApiKey()) return;
      const url = this.urlOnlyControlBalanza+this.diccionarioUrlOnlyCon.sentido+"/"+this.usuarioActual;
      //const headers = this.getHeader();
      let response;
      
      //response = this.http.post<IResponseApiOnlyServices<String>>(url, request, {headers});
      response = this.commom.peticionPostConHeader(url, request);
      return response;

    }
    
    // mensajes marquesinas
    postMensaje(request: IMensajesRequest){
      if (!this.getValidationApiKey()) return;
      const url = this.urlOnlyControlBalanza+this.diccionarioUrlOnlyCon.marquesina+"/"+this.usuarioActual;
      //const headers = this.getHeader();
      let  response;

      //response = this.http.post<any>(url, request, {headers});
      response = this.commom.peticionPostConHeader(url, request);
      return response;
    }

    // consulta status basculas
    getStatusBasqula(request: IBasculaSentidoRequest){
      if (!this.getValidationApiKey()) return;
      const url = this.urlOnlyControlBalanza+this.diccionarioUrlOnlyCon.statusBascula+"/"+this.usuarioActual;
      //const headers = this.getHeader();
      let  response;

      //response = this.http.post<IResponseApiOnlyServices<StatusSentidoDetalle>>(url, request, {headers});
      response = this.commom.peticionPostConHeader(url, request);
      return response;
    }

}